export const timeZoneOptions = [
  { label: "(GMT+08:00) 台北", value: "Asia/Taipei" },
  { label: "(GMT+07:00) 曼谷", value: "Asia/Bangkok" },
  { label: "(GMT+09:00) 東京", value: "Asia/Tokyo" },
  { label: "(GMT+09:00) 首爾", value: "Asia/Seoul" },
  { label: "(GMT+08:00) 新加坡", value: "Asia/Singapore" },
  { label: "(GMT+08:00) 香港", value: "Asia/Hong_Kong" },
  { label: "(GMT+08:00) 吉隆坡", value: "Asia/Kuala_Lumpur" },
  { label: "(GMT+07:00) 胡志明市", value: "Asia/Ho_Chi_Minh" },
  { label: "(GMT+08:00) 馬尼拉", value: "Asia/Manila" },
  { label: "(GMT+08:00) 上海", value: "Asia/Shanghai" },
];

export const tagsOptions = [];

export const countryOptions = [{ label: "台灣", value: "台灣" }];

export const cityOptions = [];

// # 付款狀態
export const orderStatus = [
  {
    value: 0,
    label: "-",
  },
  {
    value: 1,
    label: "訂單未付款",
  },
  {
    value: 2,
    label: "訂單待確認",
  },
  {
    value: 4,
    label: "訂單已付款",
  },
  {
    value: 8,
    label: "整筆訂單退款",
  },
  {
    value: 16,
    label: "部分訂單退款",
  },
  {
    value: 32,
    label: "建立失敗",
  },
];

// # 報到狀態
export const shipStatus = [
  {
    value: 0,
    label: "-",
  },
  {
    value: 1,
    label: "未簽到",
  },
  {
    value: 2,
    label: "已簽到",
  },
];

// # 退換票狀態
export const afterSaleStatus = [
  {
    value: 0,
    label: "-",
  },
  {
    value: 1,
    label: "更換",
  },
  {
    value: 2,
    label: "退款",
  },
];
